<template>
  <v-card flat>
    <div v-if="requestEmail" class="text-center painel mx-auto">
      <background-wrapper>
        <div>
          <h1 class="text-wrap">
            <span>Esqueceu sua senha?</span>
          </h1>
          <p class="mb-8">
            <span v-if="responseErrors.length > 0"> Ooops :( </span>
            <span v-else>
              Insira abaixo seu login para solicitar um link de
              <br class="d-none d-sm-block" />redefinição de senha.
            </span>
          </p>
          <cs-message v-show="responseErrors.length > 0" v-model="responseErrors" />
          <cs-message v-show="trusthubError" v-model="trusthubError" />
          <v-form ref="form">
            <cs-text-field
              class="login_field"
              v-model="login"
              label="Login"
              :error-messages="loginErrors"
              @change="validateField"
              @keydown="resetResponseErrors"
              required
            />
            <cs-recaptcha
              ref="vue_recaptcha"
              v-if="!captchaNotRequired"
              v-model="recaptcha"
              :sitekey="global.recaptchaKey"
            />
            <request
              id="solicitar_link"
              method="post"
              class="w-100"
              :style="{ color: allowSubmit ? '#fff' : '#888888 !important' }"
              :headers="headers"
              :params="params"
              :url="global.sendEmailResetPasswordUrl"
              :value="payload"
              :disabled="!allowSubmit"
              @resolved="resolved"
            >
              Solicitar link
            </request>
          </v-form>
        </div>
      </background-wrapper>
    </div>
    <SuccessfulLink v-else />
  </v-card>
</template>

<script>
import csTextField from '@/components/campos/csTextField.vue'
import csRecaptcha from '@/components/campos/csRecaptcha.vue'
import Request from '@/components/Request.vue'
import csMessage from '@/components/campos/csMessage.vue'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'
import SuccessfulLink from '../SuccessfulLink.vue'
import BackgroundWrapper from '@/components/background/BackgroundWrapper.vue'
import { recaptchaDisabledUrls } from '@/constants'

export default {
  components: {
    csMessage,
    csTextField,
    csRecaptcha,
    Request,
    SuccessfulLink,
    BackgroundWrapper
  },
  mixins: [validationMixin],

  validations() {
    return {
      login: { required }
    }
  },
  data() {
    return {
      requestEmail: true,
      login: '',
      responseErrors: [],
      recaptcha: '',
      captchaRequired: true
    }
  },
  mounted() {
    this.checkCaptchaRequirement()
  },
  computed: {
    ...mapState(['global']),
    captchaNotRequired() {
      var isDisabled = recaptchaDisabledUrls.some((u) => window.location.hostname === u)
      return isDisabled || !this.captchaRequired
    },
    loginErrors() {
      const errors = []
      if (!this.$v.login.$dirty) return errors
      !this.$v.login.required && errors.push('Esse campo é obrigatório.')
      return errors
    },
    headers() {
      const headerContent = { 'Content-Type': 'application/json' }
      if (this.requestToken) {
        headerContent.RequestVerificationToken = this.requestToken
      }
      return headerContent
    },
    params() {
      return this.$route.query
    },
    payload() {
      return {
        login: this.login,
        recaptcha: this.recaptcha
      }
    },
    allowSubmit() {
      const fakeKeyRepactcha = 'f9c7af7ebcbf098b9f5f37361d1b168bb2e5b98d930ceef0f055377a8c94db6'
      if (this.captchaNotRequired) this.recaptcha = fakeKeyRepactcha
      return this.recaptcha !== '' && this.login && this.loginErrors.length === 0
    },
    trusthubError() {
      return [this.$route.params.trustHubError]
    }
  },
  methods: {
    handleGoBack() {
      this.$router.go(this.$route.currentRoute)
    },
    resolved(response) {
      this.resetResponseErrors()

      this.requestEmail = false

      this.responseErrors.push(response.data.errors[''][0])
    },
    validateField() {
      this.$v.login.$touch()
    },
    resetResponseErrors() {
      this.responseErrors = []
    },
    checkCaptchaRequirement() {
      this.$http.get('/api/v3/account/captcha-required').then((response) => {
        this.captchaRequired = response.data.isRequired
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login_field {
  ::v-deep .v-input {
    margin-bottom: 1rem !important;
  }
}

#float {
  float: right;
}

.successful_link_image {
  background-repeat: no-repeat;
}

@media (min-width: 600px) and (max-width: 959px) {
  .login_field {
    min-width: 36.5rem !important;
  }
}

@media (min-width: 960px) and (max-width: 1263px) {
  .login_field {
    min-width: 23.625rem !important;
  }
}

@media screen and (max-width: 1490px) {
  .successful_link_image {
    background-repeat: no-repeat;
    width: 50%;
    height: 50%;
  }
}
</style>
